import { render, staticRenderFns } from "./BusinessModuleList.vue?vue&type=template&id=2e60acee&"
import script from "./BusinessModuleList.vue?vue&type=script&lang=js&"
export * from "./BusinessModuleList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports